<template>
  <div id="fensi" class="relativeItem">
    <!--openinstall的cdn链接-->
    <remote-js src="//res.cdn.openinstall.io/openinstall.js"></remote-js>

    <!-- 顶部的 -->
    <div class="relativeItem">
      <img class="noevents-img imgBlock" src="../../assets/share/fentop.png" />
      <div class="f_tit absoluteItem centerX flex-box">
        <img class="noevents-img" src="../../assets/share/dou01.png" />
        &nbsp;
        <p class="declara_box flex-box">
          {{ fansObj.declaration }}&nbsp;
          <img class="noevents-img" src="../../assets/share/dou02.png" />
        </p>
      </div>
      <div class="img_box absoluteItem centerX">
        <img :src="fansObj.family_avatar" />
      </div>
      <div class="btn_fen flex-box absoluteItem centerX">
        <i class="name_i apostrophe">{{ fansObj.family_name }}</i>
      </div>
    </div>

    <!-- 立即加入群聊按钮点击 -->
    <div class="relativeItem">
      <img class="noevents-img imgBlock" src="../../assets/share/cimg.png" />
      <div class="li_btn absoluteItem centerX" @click="showRegtc">
        <img
          class="noevents-img imgBlock"
          src="../../assets/share/lidbtn.png"
        />
      </div>
    </div>

    <!-- 粉丝头像 -->
    <div class="fen_big relativeItem">
      <div class="fen_main">
        <img
          class="zhexie noevents-img imgBlock"
          src="../../assets/share/zhexie.png"
        />
        <div class="user_box flex-box">
          <div
            class="user_img"
            v-for="(n, i) in fansArr"
            :key="i"
            :style="{ width: ubox_width + 'px', height: ubox_width + 'px' }"
          >
            <img :src="n.avatar" />
          </div>
        </div>
        <a class="imgBlock" id="download3">
          <img
            class="more_img noevents-img imgBlock"
            src="../../assets/share/more.png"
          />
        </a>
      </div>
    </div>
    <!-- 底部的 -->
    <div class="bot_main flex-box">
      <div class="l_img">
        <img
          class="imgBlock noevents-img"
          src="../../assets/share/zhubei.png"
        />
      </div>
      <div class="r_btn imgBlock" id="download1">
        <img
          class="imgBlock noevents-img"
          src="../../assets/share/down(99).png"
        />
      </div>
    </div>

    <!-- 选择注册方式的弹窗 -->
    <div class="tc" v-show="showreg_m" @click="closeZhuTc">
      <!--注册方式-->
      <div class="regist absoluteItem centerImg whiteB radius1rem" @click.stop>
        <div class="logimg" @click="showLogin = 1">
          <img src="../../assets/share/mobile.png" />
        </div>
        <div class="logimg martop8" @click="loginWx">
          <img src="../../assets/share/wx.png" />
        </div>
      </div>

      <!--手机注册-->
      <div
        class="login absoluteItem centerImg whiteB radius1rem"
        @click.stop
        v-if="showLogin == 1"
      >
        <div class="tit_top">手机注册</div>
        <p class="phone_num">
          <input
            type="tel"
            maxlength="11"
            placeholder="请输入手机号码"
            v-model="phone"
          />
        </p>
        <p class="relativeItem flex-box">
          <input
            type="text"
            maxlength="6"
            placeholder="请输入图片验证码"
            v-model="imgcode"
          />
          <img :src="imgcodeurl" class="imgy" @click="getImgCode" />
        </p>
        <p class="relativeItem flex-box">
          <input
            type="number"
            maxlength="6"
            placeholder="请输入验证码"
            v-model="yzm"
          />
          <span :class="{ disable: !getCode }" @click="getNumcode">{{
            codeText
          }}</span>
        </p>
        <div class="pass_box">
          <input
            type="password"
            v-model="pass"
            placeholder="请设置密码（不少于6个字符）"
          />
        </div>
        <span class="error" v-show="errormsg">{{ errmsg }}</span>
        <!-- 确定注册按钮 -->
        <div class="relativeItem confirm_btn radius3" @click="confirm_regbtn">
          <img src="../../assets/share/tcreg.png" />
        </div>
      </div>
    </div>

    <!-- 去朱贝的弹窗 -->
    <div class="tc" v-show="regist == 1" @click="regist = 0">
      <div class="zhu_box absoluteItem centerImg" @click.stop>
        <p>去“朱贝”了解更多详情</p>
        <div class="dapp" id="download2">
          <img src="../../assets/share/dapp.png" />
        </div>
      </div>
    </div>
  </div>
</template>












<script>
let Base64 = require("js-base64").Base64;

export default {
  components: {
    "remote-js": {
      render(createElement) {
        return createElement("script", {
          attrs: { type: "text/javascript", src: this.src },
        });
      },
      props: {
        src: { type: String, required: true },
      },
    },
  },
  data() {
    return {
      showreg_m: false,
      showLogin: 0, //0注册方式 1手机注册
      ubox_width: "", // 头像区域的宽度
      errormsg: false,
      errmsg: "",
      app: "fj", //显示对应app的内容
      rg: false, //手机是否可以进行注册
      codeText: "获取验证码",
      getCode: false, //是否可以获取验证码
      regist: 0, //0 隐藏  1显示下载的
      phone: "",
      yzm: "",
      pass: "",
      imgcode: "", //图片验证码
      imgcodeurl: "",
      wxl: false, //判断是否在微信中
      fansArr: [], //粉丝成员的数组
      fansObj: {}, // 粉丝群的信息
    };
  },
  mounted() {
    this.calculateUboxWidth();
    // 如果是微信登录就判断是否登录成功;
    this.loginWxF();
    this.getImgCode();
    this.getFansGroupInfo();
    // 判断是否在微信中
    this.wxl = this.$tool.inWX();
    //初始化openinstall
    let _this = this;
    setTimeout(() => {
      _this.open_install_thing();
    }, 1000);
  },
  methods: {
    /**openinstall相关事务 */
    open_install_thing() {
      /*web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据*/
      // eslint-disable-next-line
      var data = OpenInstall.parseUrlParams(); //openinstall.js中提供的工具函数，解析url中的所有查询参数
      // eslint-disable-next-line
      new OpenInstall(
        {
          /*appKey必选参数，openinstall平台为每个应用分配的ID*/
          appKey: "tj3x4l",
          /*openinstall初始化完成的回调函数，可选*/
          onready: function () {
            var m = this,
              button1 = document.getElementById("download1"),
              button2 = document.getElementById("download2"),
              button3 = document.getElementById("download3");
            /*在app已安装的情况尝试拉起app*/
            m.schemeWakeup();
            /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
            button1.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button2.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button3.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
          },
        },
        data
      );
    },

    // 获取粉丝群的信息
    getFansGroupInfo() {
      if (this.$route.query.group_id) {
        let _this = this;
        let data = {
          group_id: this.$route.query.group_id,
        };
        this.$jsonp(this.$apis("fans_group_share"), data, (res) => {
          if (res.body.data.status == 200) {
            _this.fansObj = res.body.data.data.info;
            _this.fansArr = res.body.data.data.userList;
          } else {
            _this.$tool.tip("网络错误", "50%");
          }
        });
      } else {
        this.$router.replace({ path: "/share" });
      }
    },

    closeZhuTc() {
      this.showreg_m = false;
      this.pass = '';
    },

    showRegtc() {
      this.showreg_m = true; // 显示注册登录的弹窗
      document.querySelector("#fensi").style.height = "100vh";
      document.querySelector("#fensi").style.overflowX = "hidden";
    },

    // 计算礼物盒子的高度
    calculateUboxWidth() {
      let ulBox = document.querySelector(".fen_main");
      let fatherWidth = ulBox.offsetWidth;
      this.ubox_width = fatherWidth * 0.16;
    },

    //微信登录
    loginWx() {
      if (this.$tool.inWX()) {
        //进行微信授权登录
        let l = window.location.href;
        l = Base64.encode(l);
        //如果连接上有uid 就传进去
        if (this.$tool.isStr(this.$route.query.uid)) {
          window.location.href =
            "http://oauth.fjkankan.com/index/Index/oauth.html?dourl=" +
            l +
            "&uid=" +
            this.$route.query.uid;
        } else if (this.$tool.isStr(this.$route.query.u)) {
          window.location.href =
            "http://oauth.fjkankan.com/index/Index/oauth.html?dourl=" +
            l +
            "&unid=" +
            this.$route.query.u;
        } else {
          window.location.href =
            "http://oauth.fjkankan.com/index/Index/oauth.html?dourl=" + l;
        }
      } else {
        alert("请在微信中打开");
      }
    },

    //检测微信是否登录成功
    loginWxF() {
      if (this.$tool.inWX()) {
        if (window.location.href.indexOf("token") != -1) {
          let c = window.location.href.substring(
            window.location.href.indexOf("token"),
            window.location.href.length
          );
          let token = c.split("=")[1];
          this.$cookie.setC("token", token, 3);

          //显示下载按钮
          this.regist = 1;
        }
      }
    },

    //获取数字短信验证码
    getNumcode() {
      if (this.getCode) {
        this.getCode = false;
      } else {
        return;
      }

      let _this = this;
      _this.errormsg = false;
      let data = {
        phone: this.phone,
        code: this.imgcode.toLowerCase(),
      };
      this.$jsonp(this.$apis("code"), data, (res) => {
        if (res.data.data.status == 200) {
          _this.$tool.tip("验证码已发送");
          //发送成功
          _this.getCode = false;
          let num = 59;
          let co = setInterval(() => {
            num--;
            _this.codeText = "已发送(" + num + ")";
            if (num == 0) {
              clearInterval(co);
              _this.codeText = "获取验证码";
              _this.getCode = true;
            }
          }, 1000);
        } else if (res.data.data.status == 201) {
          // 判断此账号已经存在就弹窗
          _this.showreg_m = false;
          _this.$tool.download("download", "此号码已注册", "确定");
        } else {
          //错误信息提示
          _this.errmsg = res.data.data.msg;
          _this.errormsg = true;
        }
      });
    },

    /**获取图片yzm */
    getImgCode() {
      let _this = this;
      _this.errormsg = false;
      this.$jsonp(this.$apis("imgcode"), {}, (res) => {
        if (res.data.data.status == 200) {
          _this.imgcodeurl = res.data.data.data;
        } else {
          //错误信息提示
          _this.errmsg = res.data.data.msg;
          _this.errormsg = true;
        }
      });
    },

    //手机注册
    confirm_regbtn() {
      if (this.rg) {
        this.rg = false;
      } else {
        return;
      }

      let _this = this;
      _this.errormsg = false;
      let data = {
        phone: this.phone,
        code: this.yzm,
        password: this.pass,
        uid: "0", //没有分享者的情况下
      };

      //如果链接上有userID就进行管理操作
      if (this.$tool.isStr(this.$route.query.uid)) {
        data.uid = this.$route.query.uid;
      } else if (this.$tool.isStr(this.$route.query.u)) {
        data.unid = this.$route.query.u;
      }

      this.$jsonp(this.$apis("rg"), data, (res) => {
        //注册成功,新用户下载，老用户打开app
        if (res.data.data.status == 100) {
          //老用户
          _this.showreg_m = false;
          _this.regist = 1;
        } else if (res.data.data.status == 200) {
          //新用户
          _this.showreg_m = false;
          _this.regist = 1;
          _this.$tool.tip('注册成功!', "50%");
          _this.pass = '';
        } else {
          //错误信息提示
          _this.errmsg = res.data.data.msg;
          _this.errormsg = true;
          _this.pass = '';
        }
        _this.rg = true;
      });
    },
  },
  watch: {
    showreg_m() {
      if (!this.showreg_m) {
        //相应数据清空
        this.showLogin = 0;
        (this.phone = ""), (this.yzm = ""), (this.imgcode = "");
      }
    },
    phone() {
      if (
        this.$tool.checkPhone(this.phone) &&
        this.imgcode != "" &&
        this.codeText == "获取验证码"
      ) {
        this.getCode = true;
      } else {
        this.getCode = false;
      }
    },
    imgcode() {
      if (
        this.$tool.checkPhone(this.phone) &&
        this.imgcode != "" &&
        this.codeText == "获取验证码"
      ) {
        this.getCode = true;
      } else {
        this.getCode = false;
      }
    },
    yzm() {
      if (
        this.yzm.length == 6 &&
        this.$tool.checkPhone(this.phone) &&
        this.pass.length >= 6 &&
        this.imgcode != ""
      ) {
        this.rg = true;
      } else {
        this.rg = false;
      }
    },
    pass() {
      if (
        this.yzm.length == 6 &&
        this.$tool.checkPhone(this.phone) &&
        this.pass.length >= 6 &&
        this.imgcode != ""
      ) {
        this.rg = true;
      } else {
        this.rg = false;
      }
    },
  },
};
</script>












<style scoped>
#fensi {
  width: 100%;
  background-color: #fff;
  min-height: 100vh;
}
.declara_box {
  width: 100%;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  text-overflow: -o-ellipsis-lastline;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  justify-content: space-around;
}
.f_tit {
  color: #bf7700;
  font-size: 12px;
  line-height: 1.8;
  width: 47%;
  top: 42%;

  justify-content: space-between;
}
.f_tit img {
  width: 10px;
  height: 10px;
  vertical-align: top;
}
.img_box {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  border: 1px solid #fff;
  overflow: hidden;
  padding: 1px;
  margin: 0 auto;
  margin-top: 1rem;
  bottom: 24%;
  transform: rotate(0deg), translateX(-50%);
}
.img_box img {
  width: 100%;
  overflow: hidden;
}
.btn_fen {
  max-width: 46%;
  min-width: 30%;
  justify-content: center;
  margin-top: 0.6rem;
  border: 1px solid #f79668;
  color: #ffffff;
  border-radius: 2rem;
  padding: 8px 16px;
  font-size: 16px;
  bottom: 8%;
}
.name_i {
  font-style: normal;
  text-align: center;
  display: block;
  width: 100%;
}
.li_btn {
  width: 80%;
  bottom: 30px;
}
@keyframes mymove {
  0% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
  50% {
    transform: scale(0.95);
    -webkit-transform: scale(0.95);
  }
}

@-webkit-keyframes mymove {
  0% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
  50% {
    transform: scale(0.95);
    -webkit-transform: scale(0.95);
  }
}

.li_btn img {
  width: 100%;
}
/* 粉丝头像 */
.fen_big {
  width: 100%;
  background-color: #e85a1d;
  padding-bottom: 25px;
  margin-top: -36px;
  z-index: 3;
}
.fen_main {
  width: 92%;
  margin: 0 auto;
  background-color: #fff3dc;
  border-radius: 8px;
  padding: 20px 8px;
}
.fen_main .zhexie {
  width: 65%;
  margin: auto;
}
.more_img {
  width: 28%;
  margin: auto;
  margin-top: 12px;
}

.user_box {
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 18px;
}
.user_box .user_img {
  border-radius: 50%;
  border: 2px solid #fff;
  overflow: hidden;
  margin: 6px 4%;
}

/* 登录方式的弹窗 */
.reg_tc {
  width: 70%;
  height: 200px;
  border-radius: 8px;
  background-color: #fff3dc;
}

/*注册方式*/
.logimg {
  width: 80%;
  margin: auto;
}
.martop8 {
  margin-top: 16px;
}
.regist,
.login {
  width: 74%;
  padding: 1.7rem 0;
  background-color: #fff3dc;
  transform-origin: left top;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);
  animation: showDownload 0.4s;
  -webkit-animation: showDownload 0.4s;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.login {
  width: 88%;
}
.radius1rem {
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
}
/*手机登录/注册*/
.login {
  padding: 1rem 1.2rem;
}
.login p {
  padding: 0.5rem 0.8rem;
  margin-bottom: 0.6rem;
  border: 1px solid #f0d099;
  border-radius: 2rem;
  -webkit-border-radius: 2rem;
  transform: rotateZ(360deg);
  box-sizing: border-box;
}
.login p:nth-child(4),
.login p:nth-child(3) {
  justify-content: space-between;
  align-items: center;
}

.login p:nth-child(4) input,
.login p:nth-child(3) input {
  width: 60%;
}
.login .phone_num input {
  width: 95%;
}

.login p:nth-child(4) *,
.login p:nth-child(3) * {
  vertical-align: middle;
}
.login a {
  background: rgba(255, 255, 255, 0.5);
}
.imgy {
  width: 38%;
  height: 30px;
}

input {
  font-size: 15px;
}
input::-webkit-input-placeholder {
  color: #e4a63e;
}
.login p:nth-child(4) span {
  display: inline-block;
  width: 40%;
  text-align: center;
  font-size: 12px;
  color: #e4a63e;
}
.login p:nth-child(4) .disable {
  color: #e4a63e;
}
.login p:nth-child(4) span::after {
  display: inline-block;
  position: absolute;
  content: "";
  width: 1px;
  height: 50%;
  background: #f8deb2;
  left: 60%;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}
.login .error {
  font-size: 12px;
  color: red;
}

/* ---------- */
input {
  background-color: #fff3dc;
  height: 30px;
}

.login .pass_box {
  padding: 0.5rem 0.8rem;
  margin-bottom: 0.6rem;
  border: 1px solid #f0d099;
  border-radius: 2rem;
  -webkit-border-radius: 2rem;
  transform: rotateZ(360deg);
  box-sizing: border-box;
}
.pass_box input {
  width: 95%;
}
.tit_top {
  width: 100%;
  text-align: center;
  margin-bottom: 1rem;
  font-size: 16px;
  font-weight: bold;
  color: #bf7700;
}
.confirm_btn {
  text-align: center;
  margin-top: 1rem;
}
.confirm_btn img {
  width: 100%;
}

/* 去朱贝的弹窗 */
.zhu_box {
  width: 80%;
  height: 150px;
  border-radius: 0.8rem;
  background-color: #fff3dc;
  margin: 0 auto;
}
.zhu_box p {
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: #bf7700;
  font-weight: bold;
  margin: 25px 0 40px;
}
.dapp {
  text-align: center;
}
.dapp img {
  width: 60%;
}

/* 底部的 */
.bot_main {
  width: 100%;
  height: 70px;
  background-color: #fff3dc;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.l_img {
  width: 110px;
}
.r_btn {
  width: 45%;
}
</style>


